import { TripFileObj } from "@/types/interfaces/crm";
import { IconButton } from "@mui/joy";
import { ColDef, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import { format } from "date-fns";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { useCallback } from "react";
import { parseDate } from "@/components/ItineraryBuilder/utils";
import Tooltip from "@mui/joy/Tooltip";
import NorthEastOutlinedIcon from "@mui/icons-material/NorthEastOutlined";
import { downloadClientlinqFile, openClientlinqFile } from "@/utils/clientlinqFiles";

const filesColumns: ColDef<TripFileObj>[] = [
  {
    colId: "fileName",
    headerName: "File Name",
    minWidth: 50,
    flex: 2,
    valueGetter: ({ data }: ValueGetterParams<TripFileObj>) => data?.fileName?.split("/").slice(-1)[0] || "",
  },
  {
    field: "description",
    headerName: "Description",
    flex: 2,
    valueGetter: ({ data }: ValueGetterParams<TripFileObj>) => data?.description || "_",
  },
  {
    field: "addedBy",
    headerName: "Added By",
    flex: 1,
  },
  {
    colId: "addedOn",
    headerName: "Added On",
    flex: 1,
    valueGetter: ({ data }: ValueGetterParams<TripFileObj>) =>
      data?.addedOn ? format(parseDate(data.addedOn.split("T")[0]), "MMM dd, yyyy") : "_",
  },
  {
    colId: "actions",
    headerName: "Actions",
    flex: 1,
    cellRenderer: ({ data }: ICellRendererParams<TripFileObj>) => {
      const openFile = useCallback(() => openClientlinqFile(data?.fileName), [data?.fileName]);

      const downloadFile = useCallback(() => downloadClientlinqFile(data?.fileName), [data?.fileName]);

      return (
        <>
          <Tooltip title="Open file">
            <IconButton size="sm" color="primary" onClick={openFile}>
              <NorthEastOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download">
            <IconButton size="sm" color="primary" onClick={downloadFile}>
              <CloudDownloadOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      );
    },
  },
];

export default filesColumns;
